import {
    createAsyncThunk,
    createSlice,
} from '@reduxjs/toolkit';

import {
    add,
    deleteRecord,
    fetch,
    fetchRecords,
    update,
} from '../services/SubscriptionsService.ts';


import {
    deleteOneCase,
    fetchManyCase,
    fetchOneCase,
    saveOneCase,
    updateOneCase,
} from '../../../../store/RecordsSliceCaseHelpers';
import {Subscription} from '../types';

const entityKey = 'subscriptions';

interface SubscriptionsState {
    byId: { [key: string]: Subscription },
    ids: string[],
    totalCount: number,
    loading: boolean,
    error: string
}

const initialState = {
    byId: {},
    ids: [],
    totalCount: 0,
    loading: false,
    error: '',
} as SubscriptionsState;


const normalizeRecord = (record: Subscription) => {
    return Object.assign({}, record);
};

// generates pending, fulfilled and rejected
export const fetchSubscriptions = createAsyncThunk(
    `${entityKey}/fetchRecords`,
    (query?: { limit?: number; nextToken?: string }) => {
        return fetchRecords(query)
            .then((response) => {
                if (response) {
                    return response.items.map((record: Subscription) => {
                        return normalizeRecord(record);
                    });
                }
            });
    },
);

export const fetchSubscription = createAsyncThunk(
    `${entityKey}/fetch`,
    (id: string) => {
        return fetch(id)
            .then((response) => {
                if (typeof response !== 'undefined') {
                    return normalizeRecord(response);
                }
            });
    });

export const saveSubscription = createAsyncThunk(
    `${entityKey}/add`,
    (payload: Subscription) => {

        return add(payload)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response);
                }
            });
    });

export const updateSubscription = createAsyncThunk(
    `${entityKey}/update`,
    ({
         id,
         record,
     }: { id: string, record: Subscription }) => {

        return update(id, record)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response);
                }
            });
    },
);

export const deleteSubscription = createAsyncThunk(
    `${entityKey}/deleteRecord`,
    (id: string) => {
        return deleteRecord(id)
            .then(() => id);
    },
);


export const storeSubscription = createAsyncThunk(
    `${entityKey}/store`,
    (payload: Subscription) => {
        return normalizeRecord(payload);
    },
);


const componentsSlice = createSlice({
                                        name: entityKey,
                                        initialState,
                                        reducers: {
                                            clearState: () => initialState,
                                        },
                                        extraReducers: (builder) => {
                                            // FETCH MANY
                                            fetchManyCase(builder, fetchSubscriptions, entityKey);

                                            // FETCH ONE
                                            fetchOneCase(builder, fetchSubscription);

                                            // SAVE ONE
                                            saveOneCase(builder, saveSubscription);

                                            // UPDATE ONE
                                            updateOneCase(builder, updateSubscription);

                                            updateOneCase(builder, storeSubscription);

                                            // DELETE ONE
                                            deleteOneCase(builder, deleteSubscription);
                                        },
                                    });

export default componentsSlice.reducer;



